export const apiCall = async ({ url, method = 'GET', body = null, withoutStringify = false, role = 'user' }) => {
  try {
    const token = localStorage.getItem(`token`);
    const defaultHeaders = {
      'Authorization': `Bearer ${token}`,
      // Do not set Content-Type for FormData; browser will automatically set it
    };

    if (!withoutStringify) {
      // If the body should be JSON (withoutStringify is false), add the Content-Type header
      defaultHeaders['Content-Type'] = 'application/json';
    }

    const options = {
      method,
      headers: defaultHeaders,
    };

    if (body) {
      // If body is FormData, don't stringify it
      if (body instanceof FormData) {
        options.body = body;
      } else {
        // If body is JSON, stringify it
        options.body = withoutStringify === true ? body : JSON.stringify(body);
      }
    }
    
    const baseURL = process.env.REACT_APP_API_URL

    const response = await fetch(`${baseURL}/${url}`, options);

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const msg =
        data && data.message
          ? data.message
          : `Failed to fetch: ${response.status} ${response.statusText}`;
      const err = new Error(msg);
      err.status = response.status;
      err.payload = data;
      throw err;
    }

    return data;
  } catch (error) {
    console.error('Error during API call:', error);
    throw error;
  }
};
